// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Test Section Styling */
.test-section {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 1.5rem;
  background-color: #f8f9fa;
}

/* Add Test button — left-aligned, override NextPage.min.css margin:0 auto !important */
.add-test-btn-wrap {
  display: flex !important;
  justify-content: flex-start !important;
}
.add-test-btn-wrap .button {
  margin: 0 !important;
}

.section-header {
  border-bottom: 2px solid #0B2D71;
  padding-bottom: 0.5rem;
}

.section-header h4 {
  color: #0B2D71;
}

/* Reading Items */
.reading-item {
  background-color: #ffffff !important;
}
.remove-icon{
  color: #E21836;
}
/* Form Styling */
.form-control {
  font-size: 0.9rem;
}

.form-check-input {
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;
}

/* Checkbox and label spacing for draft test selection */
.draft-test-selection input[type="checkbox"] {
  cursor: pointer;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  vertical-align: middle;
}

.draft-test-selection label {
  cursor: pointer;
  vertical-align: middle;
  margin-left: 8px;
  margin-bottom: 0;
}

/* Button spacing */
.button.mr-2 {
  margin-right: 0.5rem;
}

/* Column label styling */
label.font-gotham-narrow-bold {
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
  display: block;
}

/* Icon buttons styling - NextPage CSS aligned */
.btn-danger,
.btn-primary {
  padding: 2px 6px;
  min-width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  border-radius: 0;
  opacity: 1 !important;
}

.btn-danger {
  background-color: #97002E;
  color: #fff;
  opacity: 1 !important;
}

.btn-danger:hover {
  background-color: #97002E;
  color: #fff;
  opacity: 1 !important;
}

.btn-primary {
  background-color: #0066B2;
  color: #fff;
  opacity: 1 !important;
}

.btn-primary:hover {
  background-color: #0B2D71;
  color: #fff;
  opacity: 1 !important;
}

::ng-deep .small-icon,
.small-icon,
::ng-deep mat-icon.small-icon,
mat-icon.small-icon,
::ng-deep .mat-icon.small-icon,
.mat-icon.small-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #fff;
}

/* Table styling */
.table-sm {
  font-size: 0.875rem;
}

.table-sm th,
.table-sm td {
  padding: 0.5rem;
  vertical-align: middle;
}

/* Status Badge Styles - NextPage CSS aligned */
.status-in-progress,
.status-approved,
.status-rejected,
.status-completed,
.status-repeat,
.status-failed,
.status-cancelled,
.status-unknown {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.status-in-progress,
.status-approved,
.status-rejected,
.status-completed,
.status-repeat,
.status-failed,
.status-cancelled,
.status-unknown {
  color: #000000;
}

/* Action Panel Styles */
.action-panel-row {
  background-color: #f8f9fa;
}

.action-panel-cell {
  padding: 0.75rem !important;
}

.action-panel {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
  padding: 0.5rem;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-panel .btn {
  margin: 0;
  font-size: 0.85rem;
  padding: 0.375rem 0.75rem;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .test-section {
    padding: 1rem;
  }
  
  .table-responsive {
    font-size: 0.8rem;
  }
  
  .action-panel {
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .action-panel .btn {
    width: 100%;
  }
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 2rem;
}

.loading-container p {
  color: #0b2d71;
  font-size: 1.1rem;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/requested-tests/requested-tests.component.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,uFAAuF;AACvF;EACE,wBAAwB;EACxB,sCAAsC;AACxC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;;EAEE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;;;;EAME,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;;;;;;;;EAQE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* Test Section Styling */\n.test-section {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 1.5rem;\n  background-color: #f8f9fa;\n}\n\n/* Add Test button — left-aligned, override NextPage.min.css margin:0 auto !important */\n.add-test-btn-wrap {\n  display: flex !important;\n  justify-content: flex-start !important;\n}\n.add-test-btn-wrap .button {\n  margin: 0 !important;\n}\n\n.section-header {\n  border-bottom: 2px solid #0B2D71;\n  padding-bottom: 0.5rem;\n}\n\n.section-header h4 {\n  color: #0B2D71;\n}\n\n/* Reading Items */\n.reading-item {\n  background-color: #ffffff !important;\n}\n.remove-icon{\n  color: #E21836;\n}\n/* Form Styling */\n.form-control {\n  font-size: 0.9rem;\n}\n\n.form-check-input {\n  cursor: pointer;\n  width: 1.2rem;\n  height: 1.2rem;\n}\n\n/* Checkbox and label spacing for draft test selection */\n.draft-test-selection input[type=\"checkbox\"] {\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n\n.draft-test-selection label {\n  cursor: pointer;\n  vertical-align: middle;\n  margin-left: 8px;\n  margin-bottom: 0;\n}\n\n/* Button spacing */\n.button.mr-2 {\n  margin-right: 0.5rem;\n}\n\n/* Column label styling */\nlabel.font-gotham-narrow-bold {\n  font-size: 0.85rem;\n  margin-bottom: 0.25rem;\n  display: block;\n}\n\n/* Icon buttons styling - NextPage CSS aligned */\n.btn-danger,\n.btn-primary {\n  padding: 2px 6px;\n  min-width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  cursor: pointer;\n  text-decoration: none;\n  border-radius: 0;\n  opacity: 1 !important;\n}\n\n.btn-danger {\n  background-color: #97002E;\n  color: #fff;\n  opacity: 1 !important;\n}\n\n.btn-danger:hover {\n  background-color: #97002E;\n  color: #fff;\n  opacity: 1 !important;\n}\n\n.btn-primary {\n  background-color: #0066B2;\n  color: #fff;\n  opacity: 1 !important;\n}\n\n.btn-primary:hover {\n  background-color: #0B2D71;\n  color: #fff;\n  opacity: 1 !important;\n}\n\n::ng-deep .small-icon,\n.small-icon,\n::ng-deep mat-icon.small-icon,\nmat-icon.small-icon,\n::ng-deep .mat-icon.small-icon,\n.mat-icon.small-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  color: #fff;\n}\n\n/* Table styling */\n.table-sm {\n  font-size: 0.875rem;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.5rem;\n  vertical-align: middle;\n}\n\n/* Status Badge Styles - NextPage CSS aligned */\n.status-in-progress,\n.status-approved,\n.status-rejected,\n.status-completed,\n.status-repeat,\n.status-failed,\n.status-cancelled,\n.status-unknown {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n\n.status-in-progress,\n.status-approved,\n.status-rejected,\n.status-completed,\n.status-repeat,\n.status-failed,\n.status-cancelled,\n.status-unknown {\n  color: #000000;\n}\n\n/* Action Panel Styles */\n.action-panel-row {\n  background-color: #f8f9fa;\n}\n\n.action-panel-cell {\n  padding: 0.75rem !important;\n}\n\n.action-panel {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 0.5rem;\n  background-color: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.action-panel .btn {\n  margin: 0;\n  font-size: 0.85rem;\n  padding: 0.375rem 0.75rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 576px) {\n  .test-section {\n    padding: 1rem;\n  }\n  \n  .table-responsive {\n    font-size: 0.8rem;\n  }\n  \n  .action-panel {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n  \n  .action-panel .btn {\n    width: 100%;\n  }\n}\n\n/* Loading Container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  padding: 2rem;\n}\n\n.loading-container p {\n  color: #0b2d71;\n  font-size: 1.1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
